export default __webpack_public_path__ + "89f76029e987afb20ec20b4ff56f09ad.png";